import { useEffect, useState } from 'react';

const getIsDocumentVisible = (): boolean => {
  if (typeof document === 'undefined') return true;
  return document.visibilityState === 'visible';
};

export const useDocumentVisibility = (): boolean => {
  const [isDocumentVisible, setIsDocumentVisible] = useState<boolean>(getIsDocumentVisible);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const handleVisibilityChange = (): void => {
      setIsDocumentVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isDocumentVisible;
};
